import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const ElectronicStaffFolderPage = () => {
  const columns = [
    { key: 'folderName', label: 'Folder Name' },
    { key: 'description', label: 'Description' },
    { key: 'documentCount', label: 'Document Count' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'folderName', label: 'Folder Name', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', folderName: 'License & Certifications', description: 'Professional licenses and certifications', documentCount: '45', active: 'Yes' },
    { id: '2', folderName: 'Background Checks', description: 'Background check documents', documentCount: '32', active: 'Yes' },
    { id: '3', folderName: 'Training Records', description: 'Completed training and competencies', documentCount: '78', active: 'Yes' },
    { id: '4', folderName: 'Performance Reviews', description: 'Annual performance evaluations', documentCount: '25', active: 'Yes' },
    { id: '5', folderName: 'Health Records', description: 'TB tests, immunizations, physicals', documentCount: '56', active: 'Yes' },
    { id: '6', folderName: 'HR Documents', description: 'Employment documents, W-4, I-9', documentCount: '40', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Electronic Staff (Caregiver) Document Folder"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Folder"
      formFields={formFields}
      apiEndpoint="/setup/electronic-staff-folder"
    />
  );
};

export default ElectronicStaffFolderPage;
